var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeBanner)?_c('div',[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.$vuetify.breakpoint.smAndDown
        ? _vm.activeBanner.mobileBannerImage
        : _vm.activeBanner.desktopBannerImage,"alt":_vm.activeBanner.alt},on:{"click":_vm.clicked}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }